import React, { useEffect, useState } from 'react'
import { AXIOS } from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { ChromePicker } from 'react-color'
import { useForm } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import IntervalDatePicker from './common/IntervalDatePicker'
import { Pie } from 'react-chartjs-2'

import { PictureItem, Icons, Title } from './common/Themes'

import { setLoading, setFetch } from '../redux/actions'


const NewCodePromo = () => {

    const dispatch = useDispatch()
    const { articles, formules } = useSelector(state => state.fetch)
    const { fetch } = useSelector(state => state.config)

    const [value, setValue] = useState([null, null])
    const [color, setColor] = useState({ hex: '#FF5C00', rgb: { r: 245, g: 68, b: 46, a: .8 } })
    const [relatedArticles, setRelatedArticles] = useState('')
    const [relatedArticlesInputValue, setRelatedArticlesInputValue] = useState('')
    const [idArticles, setIdArticles] = useState([])
    const history = useHistory()

    const [percentage, setPercentage] = useState(10)

    useEffect(() => {
        setIdArticles(articles.map(({ id }) => id))
    }, [articles])

    const { handleSubmit, register, errors } = useForm()

    const onSubmit = async values => {
        try {
            dispatch(setLoading(true))
            const { label, percentage } = values
            const body = {
                pid: uuidv4(),
                label,
                percentage,
                start: new Date(value[0]._d).toISOString(),
                end: new Date(value[1]._d).toISOString(),
                articles: relatedArticles,
                status: 1,
                color: color.hex
            }

            // 👽 NEW CODE PROMO REQUEST
            await AXIOS.post('/api/v1/codepromos', body)

            history.push('/codepromos')
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeRelatedArticles = e => {
        if (idArticles.includes(e.target.value * 1)) {
            if (relatedArticles.length > 0)
                setRelatedArticles(`${relatedArticles},${e.target.value}`)
            else
                setRelatedArticles(e.target.value)

        }
        setRelatedArticlesInputValue(e.target.value)
    }

    const deleteRelatedArticles = id => {
        if (relatedArticles.includes(`${id},`))
            setRelatedArticles(relatedArticles.replace(`${id},`, ''))
        else if (relatedArticles.includes(`,${id}`))
            setRelatedArticles(relatedArticles.replace(`,${id}`, ''))
        else
            setRelatedArticles(relatedArticles.replace(`${id}`, ''))
    }

    const data = {
        labels: ['Benign', 'Malignant'],
        datasets: [{
            label: '# of Votes',
            data: [percentage, 100 - percentage],
            backgroundColor: [
                color.hex,
                '#999'
            ]
        }]
    }

    return (
        <div className="gestion">
            <div className="gestion__header">
                <h4 className="gestion__title">Nouveau code promo</h4>
            </div>
            <div className="gestion__wrapper">
                <form onSubmit={handleSubmit(onSubmit)} className="form">
                    <div className="form__container">
                        <div className="form__inputboxWrapper" style={{ width: '60%' }}>
                            <Title color={'#183a68'}>Fiche code promo :</Title>
                            <div className="form__inputboxWrapper" style={{ width: '100%' }}>

                                <div className="form__inputbox" style={{ width: '48%' }}>
                                    <label htmlFor="label" className="form__label">Label</label>
                                    <input name="label" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.name && errors.label.message}
                                </div>

                                <div className="form__inputbox" style={{ width: '48%' }}>
                                    <label htmlFor="percentage" className="form__label">Pourcentage</label>
                                    <input name="percentage" onChange={e => setPercentage(e.target.value)} type="number" defaultValue="1" min="1" max="100" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.percentage.message}
                                </div>

                                <div className="form__inputbox" style={{ width: '100%' }}>
                                    <label htmlFor="birthday" className="form__label">Intervalle de dates</label>
                                    <IntervalDatePicker value={value} setValue={setValue} />
                                </div>

                                <div style={{ marginTop: '30px' }}>
                                    <div className="form__inputbox" style={{ width: '491px' }}>
                                        <label htmlFor="relatedPack" className="form__label">Activités liés</label>
                                        <input value={relatedArticlesInputValue} onFocus={() => setRelatedArticlesInputValue('')} onChange={handleChangeRelatedArticles} type="email" name="relatedPack" ref={register()} list="relatedPack" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                                        <datalist id="relatedPack">
                                            {formules.filter(({ article }) => !relatedArticles.includes(article) && article != null).map(({ fid, article, name }) => <option className="form__dropdown" key={fid} value={article}>{name.replace("<br/>", " ")}</option>)}
                                        </datalist>
                                    </div>
                                    {formules?.map(({ article, name, image }) => {
                                        return (
                                            relatedArticles?.split(',')?.map((item, index) => {
                                                if (article?.length > 0 && article == item) return (
                                                    <div key={index} className="form__planningItem">
                                                        <PictureItem image={`${process.env.REACT_APP_SITE_MARCHAND}${image}`} style={{ width: '3rem', height: '3rem', borderRadius: '3px' }}>&nbsp;</PictureItem>
                                                        <div className="form__planningText">{name.replace('<br/>', ' ')}</div>
                                                        <Icons onClick={() => deleteRelatedArticles(article)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                                            <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                                        </Icons>
                                                    </div>
                                                )

                                            })
                                        )
                                    })}
                                </div>

                            </div>
                        </div>


                        <div className="form__container" style={{ justifyContent: 'flex-end', width: '39%', paddingRight: '20px' }}>

                            <div style={{ width: '225px', height: '225px', marginBottom: '20px' }}>
                                <Pie data={data} width={'100%'} height={'100%'} />
                            </div>

                            <div className="gestion__colorWrapper">
                                <label htmlFor="color" className="form__label">Choisir un color</label>
                                <div style={{ marginTop: '1rem' }}>
                                    <ChromePicker color={color} onChange={color => setColor(color)} />
                                </div>
                            </div>

                        </div>

                    </div>


                    <div className="gestion__buttonWrapper">
                        <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: color.hex }}>Ajouter</button>
                        <Link to='/codepromos'>
                            <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#999' }}>Fermer</button>
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default NewCodePromo